import LearnTranscriptActive from './component.jsx'
export default LearnTranscriptActive
